import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,{attrs:{"value":_vm.text,"inputmode":"decimal","placeholder":_vm.required ? 'required' : 'none',"suffix":_vm.unit,"disabled":_vm.disabled,"error":_vm.required && _vm.normaliseValue(_vm.text) === null,"dense":"","hide-details":""},on:{"input":_vm.onInput,"blur":_vm.onBlur}})}
var staticRenderFns = []

export { render, staticRenderFns }